import React, { Component } from 'react';
import Chart from 'chart.js';
import Scriba from 'react-scriba';
import { Redirect } from 'react-router-dom';
import { ChartModele } from './ChartModele';

import { Immocom } from '../../specifique/immocom';
import { DataAlarme } from '../../data/DataAlarme';

var objetState = {
    chartEnCours: null,
    chargementEnCours: false,
    redirect: false,
    afficheMessagePasDeDonnees: false
};

export class ChartSouhaitsRDV extends Component {

    _creationContent = () => {
        return <ChartModele
            titre="Souhaits par RDV"
            idChart="GraphiqueSouhaitsParRDV"
            chargementEnCours={this.state.chargementEnCours}
            afficheMessagePasDeDonnees={this.state.afficheMessagePasDeDonnees}
        />;
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _chargementDonnees() {

        this.setState({
            chargementEnCours: true,
            afficheMessagePasDeDonnees: false
        });

        let chargementNombreSouhaitsParRDV = DataAlarme._chargementNombreSouhaitsParRDV();

        chargementNombreSouhaitsParRDV
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    //Chargement des données
                    let Legendes = [];
                    let NbSouhaits = [];
                    let Couleurs = [];
                    let CouleursSurvol = [];
                    let ListeRDV1 = [];
                    let ListeRDV2 = [];
                    let ListeRDV3 = [];

                    if (objetData.length > 0) {
                        objetData.map(res => {
                            Legendes.push(res.libelle);
                            NbSouhaits.push(res.total);
                            Couleurs.push(res.couleurPrincipale);
                            CouleursSurvol.push(res.couleurSurvol);
                            ListeRDV1.push(res.conditionRechercheDateRDV1);
                            ListeRDV2.push(res.conditionRechercheDateRDV2);
                            ListeRDV3.push(res.conditionRechercheDateRDV3);
                        });

                        //On déclare this dans une variable afin de ne pas le confondre avec le this correspondant à l'objet chart
                        let _this = this;

                        var GraphiqueProgrammesParPhase = new Chart('GraphiqueSouhaitsParRDV', {
                            type: 'doughnut',
                            data: {
                                labels: Legendes,
                                datasets: [{
                                    data: NbSouhaits,
                                    backgroundColor: Couleurs,
                                    hoverBackgroundColor: CouleursSurvol,
                                    conditionRDV1: ListeRDV1,
                                    conditionRDV2: ListeRDV2,
                                    conditionRDV3: ListeRDV3
                                }]
                            },
                            options: {
                                'onClick': function (evt, item) {

                                    if (item.length > 0) {

                                        //Récupération du statut sélectionné
                                        let ElementTrav = item[0];
                                        let IndexTrav = ElementTrav._index;
                                        let RequeteConditionRDV1 = ElementTrav._chart.data.datasets[0].conditionRDV1[IndexTrav]
                                        let RequeteConditionRDV2 = ElementTrav._chart.data.datasets[0].conditionRDV2[IndexTrav]
                                        let RequeteConditionRDV3 = ElementTrav._chart.data.datasets[0].conditionRDV3[IndexTrav]

                                        if (RequeteConditionRDV1 === "0") {
                                            localStorage.setItem('filtreRDV1', 'IS NULL');
                                        } else if (RequeteConditionRDV1 === "1"){
                                            localStorage.setItem('filtreRDV1', 'IS NOT NULL');
                                        }

                                        if (RequeteConditionRDV2 === "0") {
                                            localStorage.setItem('filtreRDV2', 'IS NULL');
                                        } else if (RequeteConditionRDV2 === "1") {
                                            localStorage.setItem('filtreRDV2', 'IS NOT NULL');
                                        }

                                        if (RequeteConditionRDV3 === "0") {
                                            localStorage.setItem('filtreRDV3', 'IS NULL');
                                        } else if (RequeteConditionRDV3 === "1") {
                                            localStorage.setItem('filtreRDV3', 'IS NOT NULL');
                                        }

                                        localStorage.setItem('filtreNonReserves', true);

                                        _this.setState({
                                            redirect: true
                                        });
                                    }
                                }
                            }
                        });

                        this.setState({
                            chartEnCours: GraphiqueProgrammesParPhase,
                            chargementEnCours: false
                        })
                    }
                    else {
                        this.setState({
                            afficheMessagePasDeDonnees: true,
                            chargementEnCours: false
                        });
                    }
                }
                else {
                    let stateTemp = {};
                    stateTemp.chartEnCours = null;
                    stateTemp.chargementEnCours = false;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    componentDidMount() {
        this._chargementDonnees();
    }

    _onRechargement() {

        //On détruit le graph avant de le recharger
        if (this.state.chartEnCours !== null) {
            this.state.chartEnCours.destroy();
        }

        this._chargementDonnees();
    }

    render = () => {
        if (this.state.redirect) {
            return <Redirect to='/Prospection/ListeSouhaits' />;
        } else {
            return this._creationContent();
        }
    }
}